import { render, staticRenderFns } from "./ConfirmTradeModal.vue?vue&type=template&id=aa4fa4ee&scoped=true"
import script from "./ConfirmTradeModal.vue?vue&type=script&lang=js"
export * from "./ConfirmTradeModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmTradeModal.vue?vue&type=style&index=0&id=aa4fa4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4fa4ee",
  null
  
)

export default component.exports